jQuery(document).ready(function ($) {
    // Scroll reactions
    (function () {
        var win = $(window),
            doc = $(document),
            footer = $('#footer'),
            btnTop = $('.btn-top'),
            pcBanner = $('.pc-banner'),
            scrollbar = $('.x-scroll-bar');

        win.scroll(_.throttle(function () {
            var scrollTop = win.scrollTop(),
                bannerThresh = win.height() / 4,
                bottomThresh = doc.height() - win.height() - footer.outerHeight();
            if (scrollTop > bannerThresh) {
                btnTop.addClass('d-flex');
                pcBanner.addClass('show');
            } else {
                btnTop.removeClass('d-flex');
                pcBanner.removeClass('show');
            }
            if (scrollTop > bottomThresh) {
                btnTop.addClass('d-stop');
            } else {
                btnTop.removeClass('d-stop');
            }
        }, 250));

        win.scroll(_.throttle(function () {
            var progress = (win.scrollTop() / (doc.outerHeight() - win.height())) * 100;
            scrollbar.width(progress + '%');
        }, 100));
    })();

    // Main key visual
    (function () {
        var $keyWrap = $('#key-wrap');
        var $keyVisual = $('#key-visual'),
            adminbar = $('#wpadminbar');

        $keyVisual.attr('data-animation', 'true');
        $keyWrap.on('wheel mousewheel', function (e) {
            var delta = e.originalEvent.wheelDelta || -e.originalEvent.deltaY;
            if (delta < 0) {
                e.preventDefault();
                if (!$keyVisual.hasClass('scroll')) {
                    $keyVisual.addClass('scroll');
                    $('html, body').delay(1000).animate({
                        scrollTop: $keyWrap.next().position().top - (adminbar.length ? adminbar.height() : 0)
                    }, 1000);
                }
            }
        });

        $(window).scroll(function (e) {
            if ($(this).scrollTop() >= $keyVisual.height()) {
                $keyVisual.attr('data-animation', 'false');
                $keyVisual.removeClass('scroll');
            } else {
                $keyVisual.attr('data-animation', 'true');
            }
        });
    })();

    // Section animation
    (function () {
        var $mainSection = $('#trend, #banner, #recent, #newsroom');
        var scrollPos = $(window).scrollTop() + ($(window).height() / 3);

        animationState();

        $(window).scroll(function () {
            scrollPos = $(this).scrollTop() + ($(window).height() / 3);
            animationState();
        });

        function animationState() {
            $mainSection.each(function (i) {
                if (scrollPos >= $(this).offset().top) {
                    $(this).attr('data-animation', 'true');
                } else {
                    $(this).attr('data-animation', 'false');
                }
            });
        }
    })();

    // AOS.init();
    // menu
    $(".btn-menu").on("click", function (e) {
        e.preventDefault();
        $("html").addClass("modal-open");
        $("body").addClass("modal-open");
        $("#menu-layer").addClass("menu-on");
    });
    $(".btn-menu-close").on("click", function (e) {
        e.preventDefault();
        $("html").removeClass("modal-open");
        $("body").removeClass("modal-open");
        $("#menu-layer").removeClass("menu-on");
        $("#search-layer").removeClass("menu-on");
    });
    // menu
    $(".btn-search").on("click", function (e) {
        e.preventDefault();
        $("html").addClass("modal-open");
        $("body").addClass("modal-open");
        $("#search-layer").addClass("menu-on");
    });
    // top button
    $(".btn-top").on("click", function (e) {
        e.preventDefault();
        return $("html, body").animate({
            scrollTop: 0
        }, 1e3), !1
    });
    $(".btn-pcban-close").on("click", function (e) {
        e.preventDefault();
        $('#pc-banner').removeClass("show");
        setTimeout(function () {
            $('#pc-banner').remove();
            $("#footer-banner").remove();
        }, 100);
    });
    $(".btn-mo-open").on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("show");
        $("#mo-quick").toggleClass("show");
    });
    $(".btn-sns-open").on("click", function (e) {
        e.preventDefault();
        $(".sns-layer").addClass("show");
    });
    $(".btn-sns-close").on("click", function (e) {
        e.preventDefault();
        $(".sns-layer").removeClass("show");
    });
    $(".btn-ftban-close").on("click", function (e) {
        e.preventDefault();
        $("#footer-banner").hide();
        setTimeout(function () {
            $('#pc-banner').remove();
            $("#footer-banner").remove();
        }, 100);
    });

    function swipeDir() {
        var jbMedia = window.matchMedia('( max-width: 526px )');
        if (jbMedia.matches == true) {
            $('.cat-slider').attr('dir', 'ltr');
        } else {
            $('.cat-slider').attr('dir', 'rtl');
        }
    }

    swipeDir();
    $(window).resize(function () {
        swipeDir();
    });
    new Swiper('.cat-slider', {
        slidesPerView: 1,
        spaceBetween: 10,
        // init: false,
        navigation: {
            nextEl: '.swiper-btn-next',
            prevEl: '.swiper-btn-prev',
        },
    });

    var bannerSliderProps = {
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
        },
    };

    if (window.hasOwnProperty('bannerSlider') && 'object' === typeof window.bannerSlider) {
        var b = $.extend({
            horizontalBannersAutoplay: false,
            horizontalBennersAutoplayDelay: null
        }, window.bannerSlider.props);

        if (b.horizontalBannersAutoplay) {
            bannerSliderProps.autoplay = {
                delay: b.horizontalBennersAutoplayDelay
            };
        }
    }

    new Swiper('.banner-slider', bannerSliderProps);
});
